import { render, staticRenderFns } from "./MonthlyInspectionView.vue?vue&type=template&id=48cfc5d2&scoped=true"
import script from "./MonthlyInspectionView.vue?vue&type=script&lang=js"
export * from "./MonthlyInspectionView.vue?vue&type=script&lang=js"
import style0 from "./MonthlyInspectionView.vue?vue&type=style&index=0&id=48cfc5d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cfc5d2",
  null
  
)

export default component.exports